import type { ChangeEvent, Option } from '../types'
import Item from './Item'

type Props = {
  onChange: (obj: ChangeEvent) => void
  options: Option[]
}

const Reasons: React.FC<Props> = ({ onChange, options }) => {
  return (
    <div className="list-reasons">
      {options.map((option: Option) => (
        <Item key={option.id} onChange={onChange} {...option} />
      ))}
    </div>
  )
}

export default Reasons
